import axios from "axios";
import { GetLinksRoleByCountry } from "./GetLinksRoleByCountryAction";
import {
  updateLinkRoleRequested,
  updateLinkRoleRequestSucceeded,
  updateLinkRoleRequestFailed,
} from "../slices/UpdateLinkRoleSlice";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/UpdateLinkRole`;
const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const UpdateLinkRole = (idLinkRole, idRole, idLink) => async (dispatch) => {
  try {
    dispatch(updateLinkRoleRequested());

    const putData = {
      idLinkRole: Number(idLinkRole),
      idRole: Number(idRole),
      idLink: Number(idLink),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(apiUrl, putData, axiosConfig);

    dispatch(updateLinkRoleRequestSucceeded(response.data));
    await dispatch(GetLinksRoleByCountry());

    return { success: true, message: response.data };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;

    dispatch(updateLinkRoleRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
